import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Icon } from 'semantic-ui-react';

const EditRoleActionButton = ({ disabled, onClick }) => (
  <Button primary icon disabled={disabled} onClick={onClick} size="tiny" className="mt-5">
    <Icon name="external alternate" />
    &nbsp; &nbsp;
    <FormattedMessage id="role.actions.edit" />
  </Button>
);

export default EditRoleActionButton;
